import API from "serviceshift-ui/api-client";

export default {
  createVendor({ dispatch }, { deptId, data }) {
    return API.vendors.create(deptId, { vendor: data }).then(() => {
      return dispatch("fetchVendors", { deptId });
    });
  },
  deleteVendor({ dispatch }, { deptId, id }) {
    return API.vendors.delete(deptId, id).then(() => {
      return dispatch("fetchVendors", { deptId });
    });
  },
  downloadPrices(_, { deptId, id }) {
    return API.vendors.downloadPrices(deptId, id);
  },
  fetchVendors({ commit }, { deptId }) {
    return API.vendors.getAll(deptId).then((res) => {
      commit("replace", {
        state: "vendors",
        data: res.data,
      });
    });
  },
  updateVendor({ dispatch }, { deptId, data }) {
    return API.vendors.update(deptId, data.id, { vendor: data }).then(() => {
      return dispatch("fetchVendors", { deptId });
    });
  },
  uploadPrices(_, { deptId, id, data }) {
    return API.vendors.uploadPrices(deptId, id, data);
  },
};
